import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-time-axis",
  "use": "app-icon-time-axis-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"app-icon-time-axis\"><path d=\"M2.03 8.7H.7c-.387 0-.7-.336-.7-.75s.313-.75.7-.75h1.34a8.001 8.001 0 0115.92 0h1.34c.387 0 .7.336.7.75s-.313.75-.7.75h-1.33a8 8 0 01-15.94 0zM10 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM11.04 9A1.2 1.2 0 119.5 7.309V5.5a.5.5 0 011 0v1.809c.26.12.471.33.591.591h1.959a.55.55 0 010 1.1h-2.01z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol